/* Colour swatches under every product card.

   Broadcast's own grid swatch is a link to a sibling PRODUCT, painted from the
   theme.sibling_color metafield. This catalogue never set that metafield, so
   every disc resolved to var(--) and rendered grey, and after the duplicate
   listings were removed most products have one sibling or none. The row this
   builds instead shows the colours the product itself comes in, taken from its
   Colour option: each disc is a link to that colourway's variant, and pointing
   at one previews its photo on the card.

   The data file is built by qa/gen_card_swatches.py (4 Nov; was swatch_v2.py) and
   holds, per product handle, [colour name, CSS colour, variant id, photo URL] for
   every Colour value. Rebuild and re-point it after catalogue changes.
   Styling lives in pawd-sibling-swatch.css. */
(function () {
  var SWATCHES = 'https://cdn.shopify.com/s/files/1/0769/5391/1611/files/pawd-swatches-v5-202611041724.json?v=1793773470';
  var MAX_DOTS = 6;
  var PREVIEW_WIDTHS = [320, 480, 640, 800];

  var data = null, loading = null;
  function load() {
    if (loading) return loading;
    loading = fetch(SWATCHES, { cache: 'force-cache' })
      .then(function (r) { return r.json(); })
      .then(function (d) { data = d; return d; })
      .catch(function () { data = {}; return data; });
    return loading;
  }

  /* The card, not the text column: .product-item__info sits inside
     div.product-information, which holds the title and price but none of the
     image layers, so the element the preview works on has to be the grid item
     above it. */
  function cardOf(info) {
    return info.closest('.product-item, [data-grid-item]') ||
           info.closest('[data-product-information]') || info;
  }

  function handleOf(card) {
    var a = card.querySelector('a.product-link[href*="/products/"]') ||
            card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function sized(url, w) {
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  function mainImg(card) {
    return card.querySelector('[data-product-image-default] img') ||
           card.querySelector('.product-item__image img');
  }

  /* Only the default figure is rewritten. The stylesheet holds the card's
     second-image and variant-image layers down while .pawd-swatch-preview is
     set, so the colour the shopper pointed at is the one on screen. */
  function preview(card, url) {
    if (!url) return;
    var img = mainImg(card);
    if (!img) return;
    if (img.dataset.pawdSrc === undefined) {
      img.dataset.pawdSrc = img.getAttribute('src') || '';
      img.dataset.pawdSrcset = img.getAttribute('srcset') || '';
    }
    img.setAttribute('src', sized(url, 800));
    img.setAttribute('srcset', PREVIEW_WIDTHS.map(function (w) {
      return sized(url, w) + ' ' + w + 'w';
    }).join(', '));
    card.classList.add('pawd-swatch-preview');
  }

  function unpreview(card) {
    var img = mainImg(card);
    if (img && img.dataset.pawdSrc !== undefined) {
      img.setAttribute('src', img.dataset.pawdSrc);
      if (img.dataset.pawdSrcset) img.setAttribute('srcset', img.dataset.pawdSrcset);
      else img.removeAttribute('srcset');
    }
    card.classList.remove('pawd-swatch-preview');
  }

  function paint() {
    if (!data) return;
    document.querySelectorAll('.product-item__info').forEach(function (info) {
      if (info.dataset.pawdSwatched) return;
      var card = cardOf(info);
      var h = handleOf(card);
      if (!h) return;
      info.dataset.pawdSwatched = '1';
      var colours = data[h];
      if (!colours || colours.length < 2) return;

      var row = document.createElement('div');
      row.className = 'pawd-card-swatches';
      colours.slice(0, MAX_DOTS).forEach(function (c) {
        var name = c[0], css = c[1], variant = c[2], photo = c[3];
        var dot = document.createElement(variant ? 'a' : 'span');
        dot.className = 'pawd-card-swatch';
        dot.style.background = css;
        dot.title = name;
        dot.setAttribute('aria-label', name);
        if (variant) {
          dot.setAttribute('href', '/products/' + h + '?variant=' + variant);
          dot.addEventListener('mouseenter', function () { preview(card, photo); });
          dot.addEventListener('focus', function () { preview(card, photo); });
          dot.addEventListener('blur', function () { unpreview(card); });
        }
        row.appendChild(dot);
      });
      row.addEventListener('mouseleave', function () { unpreview(card); });

      if (colours.length > MAX_DOTS) {
        var more = document.createElement('a');
        more.className = 'pawd-card-swatch-more';
        more.setAttribute('href', '/products/' + h);
        more.title = 'All ' + colours.length + ' colours';
        more.textContent = '+' + (colours.length - MAX_DOTS);
        row.appendChild(more);
      }

      var link = info.querySelector('a.product-link');
      if (link && link.nextSibling) info.insertBefore(row, link.nextSibling);
      else info.appendChild(row);
    });
  }

  load().then(paint);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint);
  else paint();

  /* Filtering, infinite scroll and the quick-add drawer all replace cards. */
  var pending = null;
  new MutationObserver(function () {
    clearTimeout(pending);
    pending = setTimeout(paint, 120);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
